<form [formGroup]="formGroup">
  @for (configuration of tenantConfiguration$ | async; track configuration) {
    <div class="crm-configuration-forms-item">
      @switch (configuration.type) {
        @case ('BOOLEAN') {
          <div class="field-and-info-icon margin-bottom">
            <mat-slide-toggle
              color="primary"
              [formControlName]="configuration.label"
            >
              {{ configuration.label | i18nextCap }}
            </mat-slide-toggle>
            @if (configuration.description) {
              <div
                class="icon blue-icon no-margin-bottom"
                [matTooltip]="configuration.description | i18nextCap"
              >
                <fa-icon [icon]="faCircleInfo" size="xl"></fa-icon>
              </div>
            }
          </div>
        }
        @case ('EMAIL') {
          <div class="field-and-info-icon">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{ configuration.label | i18nextCap }}</mat-label>
              <input
                matInput
                placeholder="email@example.com"
                [formControlName]="configuration.label"
              />
              <mat-error>{{
                getFieldErrorMessage(configuration.label) | i18nextCap
              }}</mat-error>
            </mat-form-field>
            <div
              class="icon blue-icon"
              [matTooltip]="configuration.description | i18nextCap"
            >
              <fa-icon [icon]="faCircleInfo" size="xl"></fa-icon>
            </div>
          </div>
        }
        @case ('INTEGER') {
          <div class="field-and-info-icon">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{ configuration.label | i18nextCap }}</mat-label>
              <input
                class="number"
                matInput
                type="number"
                [min]="configuration.options.min || 0"
                [max]="configuration.options.max || undefined"
                step="1"
                [formControlName]="configuration.label"
                [required]="configuration.required"
              />
              <mat-error>{{
                getFieldErrorMessage(configuration.label)
                  | i18nextCap
                    : {
                        max: configuration.options.max,
                        min: configuration.options.min,
                      }
              }}</mat-error>
            </mat-form-field>
            @if (configuration.description) {
              <div
                class="icon blue-icon"
                [matTooltip]="configuration.description | i18nextCap"
              >
                <fa-icon [icon]="faCircleInfo" size="xl"></fa-icon>
              </div>
            }
          </div>
        }
        @case ('SELECT') {
          <div>
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{ configuration.label | i18nextCap }}</mat-label>
              <mat-select
                [formControlName]="configuration.label"
                [required]="configuration.required"
              >
                @for (option of configuration.options.values; track option) {
                  <mat-option [value]="option">
                    {{ option | i18nextCap }}
                  </mat-option>
                }
              </mat-select>
              <mat-error>{{
                getFieldErrorMessage(configuration.label) | i18nextCap
              }}</mat-error>
            </mat-form-field>
          </div>
        }
        @case ('TEXT') {
          <div>
            <mat-form-field
              class="d-block"
              class="full-width"
              appearance="outline"
            >
              <mat-label>{{ configuration.label | i18nextCap }}</mat-label>
              <input
                matInput
                class="full-width"
                [formControlName]="configuration.label"
                [required]="configuration.required"
              />
              <mat-error>{{
                getFieldErrorMessage(configuration.label) | i18nextCap
              }}</mat-error>
            </mat-form-field>
          </div>
        }
        @case ('IMAGE') {
          <div>
            <crm-drop-input
              [formControlElement]="
                $any(formGroup.controls[configuration.label])
              "
              [errorMessage]="
                getFieldErrorMessage(configuration.label) | i18nextCap
              "
              [height]="200"
              [description]="configuration.description | i18nextCap"
              [label]="configuration.label"
              [configuration]="configuration"
              (uploadTemplateEmitter)="uploadImage($event, configuration.label)"
            ></crm-drop-input>
          </div>
        }
      }
    </div>
  }
  <!-- <button mat-flat-button color="primary" (click)="submit()">
{{ 'save' | i18nextCap }}
</button> -->
</form>
<ng-content></ng-content>
